const Route = (startPoint = {}) => ({
  name: '',
  duration: '',
  distance: '',
  startPoint: startPoint,
  start_point_address: '',
  start_point_id: '',
  end_point_id: '',
  period_id: '',
  weekday_id: '',
  polyline: [],
  points: [],
})

export default Route
